import React, { useState } from "react";
import { MailOutlined } from "@ant-design/icons";
import { Fade } from "react-awesome-reveal";
import { useHistory } from "react-router-dom";
import type { MenuProps } from "antd";
import {
  Menu,
  Layout,
  Row,
  Image,
  Typography,
  Col,
  Card,
  List,
  Carousel,
  Divider,
} from "antd";
import { t } from "i18next";

//@ts-ignore
import mainmov3 from "../../assets/main3.mp4";
import main1 from "../../assets/main-1.png";
import main2 from "../../assets/main-2.png";
import main3 from "../../assets/main-3.png";
import main4 from "../../assets/main-10.png";
import main5 from "../../assets/main-11.png";
import img100 from "../../assets/100-min.png";
import s from "./styles.module.css";
import { SendButton } from "../../components/SendButton";
import { items } from "../../components/Navbar/routes";

const { Content } = Layout;
const { Title, Paragraph } = Typography;

export const Main = () => {
  const history = useHistory();
  const [current, setCurrent] = useState("mail");
  const onClick: MenuProps["onClick"] = (e) => {
    setCurrent(e.key);
    history.push(e.key);
  };

  const services = [
    {
      title: "Executive Compensation",
      description:
        "Let us use our renowned platform to create data-driven strategies to assist boards in making decisions on executive compensation.",
      image: main3,
    },
    {
      title: "Board of Directors Compensation",
      description:
        "We have the tools you need to streamline decisions on compensation for board of directors pay.",
      image: main2,
    },
    {
      title: "ESG Strategy Planning",
      description:
        "Understand how your business impacts society with our super-powered analytics, outlining a strategy to make your company sustainable in environment, social, and governance.",
      image: main1,
    },
  ];
  const reasons = [
    {
      description: "Strong reputation for handling critical tasks",
      image: img100,
    },
    {
      description: "Extensive network of specialized consultants",
      image: img100,
    },
    {
      description: "Vast experience with sensitive issues",
      image: img100,
    },
    {
      description: "High adaptability and beneficial solutions",
      image: img100,
    },
    {
      description:
        "Global accolades from a variety of leading professional companies",
      image: img100,
    },
  ];
  return (
    <Layout>
      <Content>
        <Row
          style={{
            position: "absolute",
            maxWidth: "1440px",
            top: "80px",
            margin: "0 auto",
            zIndex: 100,
            right: 0,
            left: 0,
          }}
        >
          <div style={{ justifyContent: "space-between", overflowX: "scroll", width: '100%' }}>
            <Menu
              selectedKeys={[current]}
              onClick={onClick}
              mode={"horizontal"}
              items={items(t)[0].children}
              style={{
                background: "transparent",
                border: "none",
              }}
              className={s.mobileMenu}
            />
            <SendButton
              type="primary"
              shape="round"
              icon={<MailOutlined />}
              size={"large"}
            >
              {t("Get in Touch")}
            </SendButton>
          </div>
        </Row>
      </Content>
      <Carousel
        autoplay
        effect={"fade"}
        easing={"easy"}
        autoplaySpeed={8000}
        style={{ marginTop: "16px" }}
      >
        <div className={s["main-carusel-wrapper"]}>
          <video
            src={mainmov3}
            autoPlay
            loop
            muted
            className="responsive-image"
            playsInline
            style={{ objectFit: "cover" }}
            disablePictureInPicture
            controls={false}
          />
          <Content
            style={{ padding: "24px", maxWidth: "1440px", margin: "0 auto" }}
          >
            <Row className={s["main-carusel-row"]}>
              <Col xs={24} md={12} style={{ zIndex: 2 }}>
                <div className={s["main-carusel-title"]} style={{ zIndex: 2 }}>
                  Retain a Strong Business Powered by Insightful Decision-Making
                </div>
                <Paragraph
                  className={s["main-carusel-description"]}
                  style={{ zIndex: 2 }}
                >
                  We’re a consultancy specializing in executive compensation,
                  board affairs, and governance, providing practical solutions
                  to modern business challenges.
                </Paragraph>
              </Col>
            </Row>
          </Content>
        </div>
      </Carousel>
      <Divider />
      <Content
        style={{ padding: "24px", maxWidth: "1440px", margin: "0 auto" }}
      >
        <Row gutter={[24, 24]}>
          <Col xs={24} md={12}>
            <Card className={`${s["main-card"]} ${s["fade-in"]}`}>
              <Image src={main4} preview={false} alt="Think" />
              <Title level={3}>Think. Adapt. Succeed.</Title>
              <Paragraph>
                Our vastly experienced team of consultants is ready to navigate
                your private company boards and management teams to yield the
                best possible outcomes. We understand the tasks professionals
                face, and we assist in creating a solid path to ensure the
                utmost benefits for your business.
              </Paragraph>
            </Card>
          </Col>
          <Col xs={24} md={12}>
            <Card className={`${s["main-card"]} ${s["fade-in"]}`}>
              <Image src={main5} preview={false} alt="Expert" />
              <Title level={3}>
                Expert Guidance for Strategic, Sustainable Success.
              </Title>
              <Paragraph>
                Our consulting team brings unmatched expertise across executive
                compensation, board pay, and ESG strategy. With a deep
                understanding of industry trends, regulatory requirements, and
                governance best practices, we tailor solutions that drive
                growth, attract top talent, and position your company for
                long-term, responsible success.
              </Paragraph>
            </Card>
          </Col>
        </Row>
        <Divider />
        <Fade cascade triggerOnce damping={0.1}>
          <Row gutter={[16, 16]}>
            <Col xs={24}>
              <Card className={`${s["main-card"]} ${s["fade-in"]}`}>
                <Title level={3}>How Can We Help?</Title>
                <List
                  itemLayout={"horizontal"}
                  dataSource={services}
                  renderItem={(item) => (
                    <Fade cascade triggerOnce damping={0.1}>
                      <List.Item>
                        <List.Item.Meta
                          avatar={
                            <Image
                              src={item.image}
                              height={100}
                              preview={false}
                            />
                          }
                          title={item.title}
                          description={item.description}
                        />
                      </List.Item>
                    </Fade>
                  )}
                />
              </Card>
            </Col>
          </Row>
          <Divider />
          <Row gutter={[16, 16]}>
            <Col xs={24}>
              <Card className={`${s["main-card"]} ${s["fade-in"]}`}>
                <Title level={3}>Why Choose Us?</Title>
                <List
                  itemLayout={"horizontal"}
                  dataSource={reasons}
                  renderItem={(item) => (
                    <Fade delay={500} cascade triggerOnce damping={0.1}>
                      <List.Item>
                        <List.Item.Meta
                          style={{ display: "flex", alignItems: "center" }}
                          avatar={<Image src={item.image} />}
                          description={item.description}
                        />
                      </List.Item>
                    </Fade>
                  )}
                />
              </Card>
            </Col>
          </Row>
          <Divider />
          <Row justify="center" className={s["main-footer"]}>
            <Col>
              <Paragraph>
                Take the Reigns and Secure Your Future. Let’s future-proof your
                business with confident decisions on executive compensation,
                board of directions pay, and ESG. Our consultants are available
                to discuss your needs with battle-hardened solutions to set your
                company in the right direction.
              </Paragraph>
              <SendButton
                type="primary"
                size="large"
                className={s["main-button"]}
              >
                {t("Get in Touch")}
              </SendButton>
            </Col>
          </Row>
        </Fade>
      </Content>
    </Layout>
  );
};
